import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["mainRef"];
function HintComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r0.disabled)("closed", ctx_r0.hasReadMore && !ctx_r0.isOpen)("opened", ctx_r0.isOpen)("formMargins", ctx_r0.useFormMargins && !ctx_r0.hasReadMore ? true : false);
    i0.ɵɵpropertyInterpolate("id", "mainHint_" + ctx_r0.randomId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.text, " ");
  }
}
function HintComponent_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r0.disabled)("closed", ctx_r0.hasReadMore && !ctx_r0.isOpen)("opened", ctx_r0.isOpen)("formMargins", ctx_r0.useFormMargins && !ctx_r0.hasReadMore ? true : false);
    i0.ɵɵpropertyInterpolate("id", "mainHint_" + ctx_r0.randomId);
    i0.ɵɵproperty("innerHtml", ctx_r0.text, i0.ɵɵsanitizeHtml);
  }
}
function HintComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵlistener("click", function HintComponent_ng_container_4_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.setExpandedFocus(!ctx_r0.isOpen, false));
    })("keyup.enter", function HintComponent_ng_container_4_Template_div_keyup_enter_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.setExpandedFocus(!ctx_r0.isOpen, true));
    })("keyup.space", function HintComponent_ng_container_4_Template_div_keyup_space_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.setExpandedFocus(!ctx_r0.isOpen, true));
    });
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("formMargins", ctx_r0.useFormMargins ? true : false);
    i0.ɵɵattribute("aria-controls", "mainHint_" + ctx_r0.randomId)("aria-expanded", ctx_r0.isOpen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r0.isOpen);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.readMoreLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r0.isOpen);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.readLessLabel, " ");
  }
}
let HintComponent = /*#__PURE__*/(() => {
  class HintComponent {
    constructor() {
      this.isOpen = false;
      this.hasReadMore = false;
      this.disabled = false;
      this.useInnerHtml = false;
      this.rebrand = false;
      // undocumented input, used in form/input/select
      // used to add margin-bottom to stb-hint > p & readMoreBtn if used
      this.useFormMargins = false;
      // margin-bottom escape hatch (used in form:input/select/textarea)
      // will eventually replace useFormMargins
      this.mb = '';
    }
    ngOnInit() {
      this.randomId = Math.random().toString(36).substring(7);
    }
    // need to do this in a function, onChanges do not fire
    // when boolean input is changed from inside this component (?!)
    setExpandedFocus(open, isKeyboard) {
      const readMoreBtn = this.mainRef.nativeElement.querySelector('.readMoreBtn');
      if (open === true) {
        this.isOpen = true;
        // focus on revealed content
        this.mainRef.nativeElement.focus();
      } else {
        this.isOpen = false;
        // we need to emulate focus-visible here, as browsers do not
        // support setting focus-options with el.focus({focusVisible: true})
        if (isKeyboard) {
          readMoreBtn.className = 'readMoreBtn keyboard-focus';
        } else {
          readMoreBtn.className = 'readMoreBtn';
        }
        setTimeout(() => {
          readMoreBtn.focus();
        });
      }
      // remove faux outline on blur
      readMoreBtn.addEventListener('blur', () => {
        readMoreBtn.className = 'readMoreBtn';
      });
    }
  }
  HintComponent.ɵfac = function HintComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HintComponent)();
  };
  HintComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HintComponent,
    selectors: [["stb-hint"]],
    viewQuery: function HintComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mainRef = _t.first);
      }
    },
    inputs: {
      text: "text",
      isOpen: "isOpen",
      hasReadMore: "hasReadMore",
      disabled: "disabled",
      readMoreLabel: "readMoreLabel",
      readLessLabel: "readLessLabel",
      useInnerHtml: "useInnerHtml",
      rebrand: "rebrand",
      useFormMargins: "useFormMargins",
      mb: "mb"
    },
    decls: 5,
    vars: 9,
    consts: [["mainRef", ""], ["tabindex", "-1", 1, "hint-container"], ["class", "hint-content", 3, "id", "disabled", "closed", "opened", "formMargins", 4, "ngIf"], ["class", "hint-content", 3, "id", "disabled", "closed", "opened", "formMargins", "innerHtml", 4, "ngIf"], [4, "ngIf"], [1, "hint-content", 3, "id"], [1, "hint-content", 3, "id", "innerHtml"], ["role", "button", "tabindex", "0", 3, "click", "keyup.enter", "keyup.space"], [1, "readMoreBtn", 3, "hidden"], [3, "hidden"]],
    template: function HintComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1, 0);
        i0.ɵɵtemplate(2, HintComponent_p_2_Template, 2, 10, "p", 2)(3, HintComponent_p_3_Template, 1, 10, "p", 3)(4, HintComponent_ng_container_4_Template, 6, 8, "ng-container", 4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("margin-bottom", ctx.mb ? ctx.mb : "");
        i0.ɵɵclassProp("disabled", ctx.disabled)("rebrand", ctx.rebrand);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.useInnerHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.useInnerHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.hasReadMore);
      }
    },
    dependencies: [i1.NgIf],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}.hint-container{font-family:Open Sans,sans-serif;font-weight:400;line-height:normal}.hint-container:focus{outline:2px solid #00f;outline-offset:4px}.hint-container:focus:not(:focus-visible){outline:0}.hint-container:focus-visible{outline:2px solid #00f;outline-offset:4px}.hint-container .keyboard-focus{outline:2px solid #00f;outline-offset:4px}.hint-container .hint-content{font-size:14px;color:#191919;line-height:24px;margin:5px 0 0}.hint-container .hint-content.disabled{color:#757575}.hint-container .hint-content.closed{overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.hint-container .hint-content.opened{height:auto;overflow:visible;display:block}.hint-container div[role=button]{margin-top:2px}.hint-container .formMargins{margin-bottom:16px}.hint-container div[role=button]{width:-moz-fit-content;width:fit-content;cursor:pointer;font-family:Open Sans,sans-serif;font-weight:400;background:0 0;border:none;padding:0;font-size:14px;text-decoration:underline;color:#191919}.hint-container.disabled div[role=button]{color:#757575}.hint-container div[role=button]:focus{outline:2px solid #00f;outline-offset:4px}.hint-container div[role=button]:focus:not(:focus-visible){outline:0}.hint-container div[role=button]:focus-visible{outline:2px solid #00f;outline-offset:4px}.hint-container.rebrand{display:inline-block;font-family:Storebrand Text,sans-serif;font-weight:400;line-height:18px}.hint-container.rebrand .keyboard-focus{outline:2px solid #0000ff;outline-offset:4px}.hint-container.rebrand .hint-content{color:var(--p-color-text-secondary, #5e5050);font-family:Storebrand Text,sans-serif;font-size:1rem;line-height:var(--p-font-styles-line-height-desktop-14, 18px);margin:0}@media (max-width: 600px){.hint-container.rebrand .hint-content{font-size:.875rem;line-height:var(--p-font-styles-line-height-mobile-14, 20px)}}.hint-container.rebrand .hint-content.disabled{color:var(--p-color-text-disabled, #b6a5a5)}.hint-container.rebrand .hint-content p,.hint-container.rebrand .hint-content *{color:var(--p-color-text-secondary, #5e5050);font-family:Storebrand Text;font-size:1rem;margin:0}.hint-container.rebrand div[role=button]{margin-top:0}.hint-container.rebrand div[role=button]{color:#700;font-size:1rem;line-height:1.5}.hint-container.rebrand div[role=button]:focus-visible{outline:2px solid #0000ff;outline-offset:4px}\n"],
    encapsulation: 2
  });
  return HintComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HintModule = /*#__PURE__*/(() => {
  class HintModule {}
  HintModule.ɵfac = function HintModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HintModule)();
  };
  HintModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HintModule
  });
  HintModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return HintModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of hint
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HintComponent, HintModule };
